import { ApiKeysActionTypes } from './constants';

type ApiKeysAction = { type: string, payload: {} | string };

export const apiKeysApiResponseSuccess = (actionType: string, data: any): ApiKeysAction => ({
    type: ApiKeysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const apiKeysApiResponseError = (actionType: string, error: string): ApiKeysAction => ({
    type: ApiKeysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const apiKeysGetAll = (userId: string): ApiKeysAction => ({
    type: ApiKeysActionTypes.GET_ALL_API_KEYS,
    payload: { userId },
});

export const apiKeysCreate = (userId: string): ApiKeysAction => ({
    type: ApiKeysActionTypes.CREATE_API_KEY,
    payload: { userId },
});

export const apiKeysDelete = (userId: string, apiKeyId: string): ApiKeysAction => ({
    type: ApiKeysActionTypes.DELETE_API_KEY,
    payload: { userId, apiKeyId },
});

export const apiKeysResetAllErrors = (): ApiKeysAction => ({
    type: ApiKeysActionTypes.RESET_ALL_ERRORS,
    payload: {},
});
